import zip from '@/js/forms/zip'
import formsSelect from '@/js/forms/select.js'
import formsInputDate from "@/js/forms/inputDate.js";

const forms = () => {
    zip();
    formsSelect()
    formsInputDate()
}

export default forms;
